//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function sharedPortfoliosGetList(skipCount?: number | undefined, maxResultCount?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultDtoOfSharedPortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/shared?";
    if (skipCount === null)
        throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
        url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
        throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
        url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSharedPortfoliosGetList,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSharedPortfoliosGetList?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSharedPortfoliosGetList(_response);
    });
}

function processSharedPortfoliosGetList(response: AxiosResponse): Promise<Types.PagedResultDtoOfSharedPortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PagedResultDtoOfSharedPortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultDtoOfSharedPortfolioDto>(null as any);
}

/**
 * @return OK
 */
export function sharedPortfoliosGetSharedPortfolio(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/shared/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSharedPortfoliosGetSharedPortfolio,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSharedPortfoliosGetSharedPortfolio?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSharedPortfoliosGetSharedPortfolio(_response);
    });
}

function processSharedPortfoliosGetSharedPortfolio(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function sharedPortfoliosCreateOrUpdateSharedPortfolio(id: string, body?: Types.SharedPortfolioSettings | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SharedPortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/shared/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSharedPortfoliosCreateOrUpdateSharedPortfolio,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSharedPortfoliosCreateOrUpdateSharedPortfolio?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSharedPortfoliosCreateOrUpdateSharedPortfolio(_response);
    });
}

function processSharedPortfoliosCreateOrUpdateSharedPortfolio(response: AxiosResponse): Promise<Types.SharedPortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SharedPortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SharedPortfolioDto>(null as any);
}

/**
 * @return OK
 */
export function sharedPortfoliosDeleteSharedPortfolioUser(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/portfolios/shared/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSharedPortfoliosDeleteSharedPortfolioUser,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigSharedPortfoliosDeleteSharedPortfolioUser?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSharedPortfoliosDeleteSharedPortfolioUser(_response);
    });
}

function processSharedPortfoliosDeleteSharedPortfolioUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @return OK
 */
export function sharedPortfoliosGetSharedPortfolioSettings(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.SharedPortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/shared/{id}/settings";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSharedPortfoliosGetSharedPortfolioSettings,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSharedPortfoliosGetSharedPortfolioSettings?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSharedPortfoliosGetSharedPortfolioSettings(_response);
    });
}

function processSharedPortfoliosGetSharedPortfolioSettings(response: AxiosResponse): Promise<Types.SharedPortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SharedPortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SharedPortfolioDto>(null as any);
}

/**
 * @param start (optional) 
 * @param end (optional) 
 * @param includeTransactions (optional) 
 * @return OK
 */
export function sharedPortfoliosGetTimeSeries(id: string, start?: string | undefined, end?: string | undefined, includeTransactions?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfBucketDto> {
    let url_ = getBaseUrl() + "/api/portfolios/shared/{id}/timeseries?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (start === null)
        throw new Error("The parameter 'start' cannot be null.");
    else if (start !== undefined)
        url_ += "Start=" + encodeURIComponent("" + start) + "&";
    if (end === null)
        throw new Error("The parameter 'end' cannot be null.");
    else if (end !== undefined)
        url_ += "End=" + encodeURIComponent("" + end) + "&";
    if (includeTransactions === null)
        throw new Error("The parameter 'includeTransactions' cannot be null.");
    else if (includeTransactions !== undefined)
        url_ += "IncludeTransactions=" + encodeURIComponent("" + includeTransactions) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSharedPortfoliosGetTimeSeries,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSharedPortfoliosGetTimeSeries?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSharedPortfoliosGetTimeSeries(_response);
    });
}

function processSharedPortfoliosGetTimeSeries(response: AxiosResponse): Promise<Types.ListResultDtoOfBucketDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfBucketDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfBucketDto>(null as any);
}

/**
 * @return OK
 */
export function sharedPortfoliosAcceptSharedPortfolio(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.SharedPortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/shared/{id}/accept";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSharedPortfoliosAcceptSharedPortfolio,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSharedPortfoliosAcceptSharedPortfolio?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSharedPortfoliosAcceptSharedPortfolio(_response);
    });
}

function processSharedPortfoliosAcceptSharedPortfolio(response: AxiosResponse): Promise<Types.SharedPortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SharedPortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SharedPortfolioDto>(null as any);
}

/**
 * @return OK
 */
export function sharedPortfoliosRevokeShareAccess(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/portfolios/shared/{id}/revoke";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSharedPortfoliosRevokeShareAccess,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigSharedPortfoliosRevokeShareAccess?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSharedPortfoliosRevokeShareAccess(_response);
    });
}

function processSharedPortfoliosRevokeShareAccess(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigSharedPortfoliosGetList: Partial<AxiosRequestConfig> | null;
export function getSharedPortfoliosGetListRequestConfig() {
  return _requestConfigSharedPortfoliosGetList;
}
export function setSharedPortfoliosGetListRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosGetList = value;
}
export function patchSharedPortfoliosGetListRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosGetList = patch(_requestConfigSharedPortfoliosGetList ?? {});
}

let _requestConfigSharedPortfoliosGetSharedPortfolio: Partial<AxiosRequestConfig> | null;
export function getSharedPortfoliosGetSharedPortfolioRequestConfig() {
  return _requestConfigSharedPortfoliosGetSharedPortfolio;
}
export function setSharedPortfoliosGetSharedPortfolioRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosGetSharedPortfolio = value;
}
export function patchSharedPortfoliosGetSharedPortfolioRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosGetSharedPortfolio = patch(_requestConfigSharedPortfoliosGetSharedPortfolio ?? {});
}

let _requestConfigSharedPortfoliosCreateOrUpdateSharedPortfolio: Partial<AxiosRequestConfig> | null;
export function getSharedPortfoliosCreateOrUpdateSharedPortfolioRequestConfig() {
  return _requestConfigSharedPortfoliosCreateOrUpdateSharedPortfolio;
}
export function setSharedPortfoliosCreateOrUpdateSharedPortfolioRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosCreateOrUpdateSharedPortfolio = value;
}
export function patchSharedPortfoliosCreateOrUpdateSharedPortfolioRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosCreateOrUpdateSharedPortfolio = patch(_requestConfigSharedPortfoliosCreateOrUpdateSharedPortfolio ?? {});
}

let _requestConfigSharedPortfoliosDeleteSharedPortfolioUser: Partial<AxiosRequestConfig> | null;
export function getSharedPortfoliosDeleteSharedPortfolioUserRequestConfig() {
  return _requestConfigSharedPortfoliosDeleteSharedPortfolioUser;
}
export function setSharedPortfoliosDeleteSharedPortfolioUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosDeleteSharedPortfolioUser = value;
}
export function patchSharedPortfoliosDeleteSharedPortfolioUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosDeleteSharedPortfolioUser = patch(_requestConfigSharedPortfoliosDeleteSharedPortfolioUser ?? {});
}

let _requestConfigSharedPortfoliosGetSharedPortfolioSettings: Partial<AxiosRequestConfig> | null;
export function getSharedPortfoliosGetSharedPortfolioSettingsRequestConfig() {
  return _requestConfigSharedPortfoliosGetSharedPortfolioSettings;
}
export function setSharedPortfoliosGetSharedPortfolioSettingsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosGetSharedPortfolioSettings = value;
}
export function patchSharedPortfoliosGetSharedPortfolioSettingsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosGetSharedPortfolioSettings = patch(_requestConfigSharedPortfoliosGetSharedPortfolioSettings ?? {});
}

let _requestConfigSharedPortfoliosGetTimeSeries: Partial<AxiosRequestConfig> | null;
export function getSharedPortfoliosGetTimeSeriesRequestConfig() {
  return _requestConfigSharedPortfoliosGetTimeSeries;
}
export function setSharedPortfoliosGetTimeSeriesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosGetTimeSeries = value;
}
export function patchSharedPortfoliosGetTimeSeriesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosGetTimeSeries = patch(_requestConfigSharedPortfoliosGetTimeSeries ?? {});
}

let _requestConfigSharedPortfoliosAcceptSharedPortfolio: Partial<AxiosRequestConfig> | null;
export function getSharedPortfoliosAcceptSharedPortfolioRequestConfig() {
  return _requestConfigSharedPortfoliosAcceptSharedPortfolio;
}
export function setSharedPortfoliosAcceptSharedPortfolioRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosAcceptSharedPortfolio = value;
}
export function patchSharedPortfoliosAcceptSharedPortfolioRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosAcceptSharedPortfolio = patch(_requestConfigSharedPortfoliosAcceptSharedPortfolio ?? {});
}

let _requestConfigSharedPortfoliosRevokeShareAccess: Partial<AxiosRequestConfig> | null;
export function getSharedPortfoliosRevokeShareAccessRequestConfig() {
  return _requestConfigSharedPortfoliosRevokeShareAccess;
}
export function setSharedPortfoliosRevokeShareAccessRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosRevokeShareAccess = value;
}
export function patchSharedPortfoliosRevokeShareAccessRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSharedPortfoliosRevokeShareAccess = patch(_requestConfigSharedPortfoliosRevokeShareAccess ?? {});
}